/**
 * Created by desheng.zhao on 2018/12/3.
 */
var tel = function (tel, sep = " ") {
  if(tel && tel.length == 11){
    return [tel.slice(0,3),tel.slice(3,7),tel.slice(7,11)].join(sep);
  }else{
    return tel;
  }
}
export default tel;


// WEBPACK FOOTER //
// ./src/filters/tel.js